var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiktok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0691 4.11284C14.9957 3.44478 14.17 2.27568 13.9222 0.939565C13.9222 0.77255 13.9222 0.689043 13.8397 0.522029V0.104492H10.4542V13.6327C10.4542 15.2193 9.21563 16.4719 7.64676 16.4719C7.15133 16.4719 6.73847 16.3884 6.40818 16.1379C5.49989 15.6368 4.83931 14.7183 4.83931 13.5492C4.83931 11.9625 6.07789 10.7099 7.64676 10.7099C7.97705 10.7099 8.22477 10.7934 8.47248 10.8769V7.45313C8.22477 7.45313 7.89448 7.36962 7.64676 7.36962C4.26131 7.36962 1.45386 10.2089 1.45386 13.6327C1.45386 15.8039 2.52729 17.7245 4.17874 18.8101C5.1696 19.4782 6.32561 19.8957 7.64676 19.8957C11.0322 19.8957 13.8397 17.0565 13.8397 13.6327V6.70157C15.1608 7.62015 16.8123 8.2047 18.5463 8.2047V4.86441C17.638 4.86441 16.8123 4.61388 16.0691 4.11284Z",
    fill: "#0D111A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.f0b2cb5f.svg";
export { ForwardRef as ReactComponent };